import styled from "styled-components";

const ModalCustom = styled.div`
  display: ${(props) => (props.isOpen ? "block" : "none")};
  height: 100vh;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.8);
  align-items: center;
  overflow: scroll;
`;

export default ModalCustom;
